import { getNextParentElement } from "../../../../common/utils/getNextParentElement";

/**
 *
 *
 */
export const findNextPositionedParent = (element: HTMLElement): HTMLElement | undefined => {
  const parentElement = getNextParentElement(element);
  if (!parentElement) return undefined;
  return getComputedStyle(parentElement).position !== "static"
    ? parentElement
    : findNextPositionedParent(parentElement);
};
